// Product Master Management — single page using MasterCrudPage tabs.
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import MasterCrudPage from "@/components/MasterCrudPage";

const KINDS = [
  { kind: "sizes",     label: "Sizes",     extra: [{ key: "length_mm", label: "Length (mm)", type: "number" }, { key: "width_mm", label: "Width (mm)", type: "number" }] },
  { kind: "finishes",  label: "Finishes" },
  { kind: "materials", label: "Materials" },
  { kind: "colors",    label: "Colors",    extra: [{ key: "hex", label: "Hex" }] },
  { kind: "patterns",  label: "Patterns" },
  { kind: "units",     label: "Units" },
  { kind: "tax_codes", label: "Tax codes", extra: [{ key: "rate", label: "Rate %", type: "number" }] },
  { kind: "hsn_codes", label: "HSN codes" },
];

export default function ProductMasters() {
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="admin-product-masters">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black">Product master data</h1>
        <p className="text-muted-foreground">Platform-wide reference data shared across all organizations: tile sizes, finishes, materials, colors, patterns, units, HSN & tax codes.</p>
      </div>
      <Tabs defaultValue="sizes">
        <TabsList>
          {KINDS.map((k) => <TabsTrigger key={k.kind} value={k.kind} data-testid={`tab-${k.kind}`}>{k.label}</TabsTrigger>)}
        </TabsList>
        {KINDS.map((k) => (
          <TabsContent key={k.kind} value={k.kind}>
            <MasterCrudPage kind={k.kind} title="" description="" extra={k.extra || []} />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
